import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "interests-modal-inner" }
const _hoisted_2 = { class: "interests-modal-header" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "font-sourcesanspro-semibold text-m2 text-white" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "font-sourcesanspro-regular text-sm text-white/50 mt-1" }
const _hoisted_7 = { class: "interests-modal-body" }

import { ref, watch, computed } from 'vue';
import { IonButton, IonModal, IonSpinner } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

import TagCollections from '@/shared/components/TagCollections.vue';
import useUserProfile from '@/modules/profile/composables/useUserProfile';
import useToast from '@/shared/composables/useToast';
import { useQueryClient } from '@tanstack/vue-query';
import type { TenantConfig } from '@/shared/interfaces/tenant';

// Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'InterestsModal',
  props: {
	isOpen: { type: Boolean, required: true, default: false },
},
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

// Init
const { locale, t } = useI18n();
const { postInterestsConfigured } = useUserProfile();
const { presentToast } = useToast();
const isOpenRef = ref(props.isOpen);
const isSubmitting = ref(false);
const selectedTagsCount = ref(0);
const tagCollectionsRef = ref<InstanceType<typeof TagCollections> | null>(null);
const hasSelectedTags = computed(() => selectedTagsCount.value > 0);

const queryClient = useQueryClient();
const tenantConfig = queryClient.getQueryCache().find(['tenantConfig']);
const interestsTranslations = (tenantConfig?.state.data as TenantConfig)?.interests_page_translations;
const interestsTitle = computed(() => interestsTranslations?.[locale.value.split('-')[0]]?.title || t('auth.sign_up_additional_page.step_seven.title'));
const interestsSubtitle = computed(() => interestsTranslations?.[locale.value.split('-')[0]]?.subtitle || t('auth.sign_up_additional_page.step_seven.subtitle'));

// Watch prop changes
watch(
	() => props.isOpen,
	(newValue) => {
		isOpenRef.value = newValue;
	},
);

// Save and close
const save = async () => {
	isSubmitting.value = true;
	try {
		await tagCollectionsRef.value?.saveTags();
		await postInterestsConfigured();
		emit('onClose');
	} catch (error) {
		await presentToast('top', t('error.general'), 5000, 'danger');
	} finally {
		isSubmitting.value = false;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    "is-open": isOpenRef.value,
    "initial-breakpoint": 0.6,
    breakpoints: [0, 0.6, 0.85],
    "backdrop-dismiss": false,
    class: "interests-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(interestsTitle.value), 1),
            _createVNode(_unref(IonButton), {
              class: "h-[30px] text-xs",
              shape: "round",
              color: "primary",
              size: "small",
              disabled: isSubmitting.value || !hasSelectedTags.value,
              onClick: save
            }, {
              default: _withCtx(() => [
                (isSubmitting.value)
                  ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                      key: 0,
                      name: "dots",
                      class: "w-4 h-4"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('form.save')), 1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(interestsSubtitle.value), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TagCollections, {
            ref_key: "tagCollectionsRef",
            ref: tagCollectionsRef,
            "user-tags": [],
            "onUpdate:tagsCount": _cache[0] || (_cache[0] = (count) => (selectedTagsCount.value = count))
          }, null, 512)
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})